import {
  GET_TRADE_ORDERS,
  GET_TRADE_ORDERS_SUCCESS,
  GET_TRADE_ORDERS_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  tradeOrders: [],
  pagination: {},
  summary: {},
  error: null,
};

const tradeOrderReducer = (state = INIT_STATE, action) => {
  switch (action?.type) {
    case GET_TRADE_ORDERS:
      return { ...state, loading: true, error: null };
    case GET_TRADE_ORDERS_SUCCESS:
      
      return {
        ...state,
        tradeOrders: action?.payload?.tradeOrders || [],
        pagination: action?.payload?.pagination || {},
        summary: action?.payload?.summary || {},
        loading: false,
        error: null,
      };
    case GET_TRADE_ORDERS_FAILURE:
      return { ...state, loading: false, error: "Failed to fetch trade orders" };
    default:
      return state;
  }
};

export default tradeOrderReducer;